/**
 * The accordion panel's height.
 * @type {number}
 */
export const accordionPanelHeight = '--accordion-panel-height';
/**
 * The accordion panel's width.
 * @type {number}
 */
export const accordionPanelWidth = '--accordion-panel-width';
